<template>
    <div id="app">
        <Dialog/>
        <Notify/>
        <Modal/>
        <router-view 
            v-if="carregado"
        />
    </div>
</template>
<script>
import { dominioNeutro } from '@/shared/common/functions/dominioNeutro'
import Vue from 'vue'
import { mapState, mapActions } from 'vuex'
import Dialog from '@/shared/components/ui/Dialog'
import Notify from '@/shared/components/ui/Notify'
import Modal from '@/shared/components/ui/Modal'
import { pegaMensagem } from '@/shared/common/functions/mensagens'
import { buscaNovidades } from '@/shared/plugins/novidades'
import { iniciaContadorOnline } from '@/shared/plugins/contadorOnline'
export default {
    components: {
        Dialog, Notify, Modal
    },
    mounted(){
        this.carregaDominio()
        this.inicializaTokenDispositivo()
        pegaMensagem()
        buscaNovidades()
        // Beacon para a Lambda do contador online (sem nada na tela; ver o arquivo do plugin)
        iniciaContadorOnline(() => this.usuarioLogado, () => {
            const rotas = (this.$route && this.$route.matched) || []
            return rotas.length ? rotas[rotas.length - 1].path : ''
        })
    },
    computed: {
        ...mapState('planos', ['empresaPlano']),
        ...mapState('dominios', ['dominio']),
        ...mapState('usuarios', ['usuarioLogado', 'tokenDispositivo']),
        carregado(){
            if(this.dominio){
                this.atualizaIcone(this.dominio)
                this.atualizaManifest(this.dominio)
            }
            return this.dominio
        }
    },
    watch:{
        dominio(dominio){
            Vue.prototype.$app = dominio
        },
        usuarioLogado(usuarioLogado){
            Vue.prototype.$usuarioLogado = usuarioLogado
        },
        tokenDispositivo: {
            handler(newTokenDispositivo) {
                Vue.prototype.$tokenDispositivo = newTokenDispositivo;
            },
            immediate: true,
        },
        empresaPlano(empresaPlano){
            Vue.prototype.$empresaPlano = empresaPlano
        },
        $route: {
            handler(rota){
                if(rota && rota.query && rota.query.referencia === 'interacao'){
                    this.abreAbaReferencia()
                }
            },
            immediate: true
        },
    },
    methods: {
        ...mapActions('dominios', ['carregaDominio']),
        ...mapActions('usuarios', ['inicializaTokenDispositivo']),
        // Notificações de menção chegam com ?referencia=interacao: ao abrir o
        // registro, ativa a aba Interações. Busca a aba pelo título/ícone em vez
        // de índice fixo, pois cada tela tem um conjunto de abas diferente
        // (algumas condicionais). Vale para todas as telas de visualização.
        abreAbaReferencia(tentativa = 0){
            const clicouAba = () => {
                const abas = document.querySelectorAll('.nav-tabs .nav-link, .nav-pills .nav-link')
                for(const aba of abas){
                    const texto = (aba.textContent || '').trim().toLowerCase()
                    const temIcone = aba.querySelector('.fa-comments, .fa-comments-o')
                    if(texto.includes('interaç') || temIcone){
                        if(!aba.classList.contains('active')){
                            aba.click()
                        }
                        return true
                    }
                }
                return false
            }
            this.$nextTick(() => {
                if(clicouAba()){
                    return
                }
                // A aba renderiza depois do carregamento assíncrono do domínio e
                // do registro; tenta de novo por até ~8s antes de desistir.
                if(tentativa < 40){
                    setTimeout(() => this.abreAbaReferencia(tentativa + 1), 200)
                }
            })
        },
        atualizaIcone(dados){
            if(!dados.caminho_favicon || dominioNeutro()){
                return
            }
            // O plugin PWA injeta DOIS <link rel="icon"> no index.html: 32x32 e
            // 16x16, ambos apontando para os icones estaticos do build. Trocar
            // so o primeiro deixava o 16x16 com o icone padrao — e e justamente
            // ele que o Chrome usa na aba. Enquanto /img/icons/favicon-16x16.png
            // nao existia o navegador descartava esse candidato e caia no 32x32
            // (o que a gente troca), por isso o favicon do dominio funcionava.
            // Alem disso, sizes/type declarados sao os do icone estatico e nao
            // batem com o arquivo do dominio (que pode ser .ico), o que faz o
            // Chrome descartar o candidato — por isso os atributos saem junto.
            const icones = document.querySelectorAll('link[rel~="icon"], link[rel="shortcut icon"]')
            if(!icones.length){
                const icone = document.createElement('link')
                icone.rel = 'icon'
                icone.href = dados.caminho_favicon
                document.head.appendChild(icone)
                return
            }
            icones.forEach((icone, indice) => {
                if(indice > 0){
                    icone.remove()
                    return
                }
                icone.removeAttribute('sizes')
                icone.removeAttribute('type')
                icone.href = dados.caminho_favicon
            })
        },
        atualizaManifest(dados){
            let manifest = {
                'name': dados.nome,
                'short_name':  dados.nome,
                'theme_color': '#' + dados.cor_primaria,
                'icons':[
                    {
                        'src': dados.caminho_favicon,
                        'sizes':'192x192',
                        'type':'image/png'
                    },
                    {
                        'src': dados.caminho_favicon,
                        'sizes':'512x512',
                        'type':'image/png'
                    },
                    {
                        'src': dados.caminho_favicon,
                        'sizes':'192x192',
                        'type':'image/png',
                        'purpose':'maskable'
                    },
                    {
                        'src': dados.caminho_favicon,
                        'sizes':'512x512',
                        'type':'image/png',
                        'purpose':'maskable'
                    }
                ],
                'start_url':'.',
                'display':'standalone',
                'background_color': '#' + dados.cor_primaria
            }

            const stringManifest = JSON.stringify(manifest);
            const blob = new Blob([stringManifest], {type: 'application/json'});
            const manifestURL = URL.createObjectURL(blob);
            document.querySelector('link[rel="manifest"]').setAttribute('href', manifestURL);

            var link = document.createElement('Link');
            link.rel = 'manifest';
            link.setAttribute('href', 'data:application/json;charset=8' + stringManifest)
        }
    }
}
</script>